import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgWindIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 27.384 23.02",
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M13.687,8.54v.01H0V5.9H13.393a1.629,1.629,0,0,0,0-3.257,2.092,2.092,0,0,0-1.441.553,10.647,10.647,0,0,0-.906.957L9.777,2.082A4.2,4.2,0,0,1,13.393,0,4.244,4.244,0,0,1,17.6,4.275,4.249,4.249,0,0,1,13.687,8.54Zm9.78,3.946v.01H7.172V9.85h16a1.629,1.629,0,0,0,0-3.257,2.092,2.092,0,0,0-1.441.553,10.646,10.646,0,0,0-.906.957l-1.27-2.074a4.2,4.2,0,0,1,3.616-2.082,4.278,4.278,0,0,1,.294,8.54ZM17.6,14.48v-.01H3.912v2.646H17.3a1.629,1.629,0,0,1,0,3.257,2.092,2.092,0,0,1-1.441-.553,10.647,10.647,0,0,1-.906-.957l-1.269,2.074A4.2,4.2,0,0,0,17.3,23.019a4.278,4.278,0,0,0,.295-8.54Z" })
});
export default SvgWindIcon;
